import { Outlet } from 'react-router-dom'

const Gears = () => {
  return <Outlet />
}

export default Gears
